import { render, staticRenderFns } from "./occupation.vue?vue&type=template&id=db8bd95c&scoped=true"
import script from "./occupation.vue?vue&type=script&lang=js"
export * from "./occupation.vue?vue&type=script&lang=js"
import style0 from "./occupation.vue?vue&type=style&index=0&id=db8bd95c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8bd95c",
  null
  
)

export default component.exports